module.exports = __webpack_public_path__ + "img/Society1.6d4ebe74.jpg";